import * as React from "react";
import { StyleProp, ViewStyle } from "react-native";
import Svg, { Path } from "react-native-svg";
import { getPrimaryColor } from "../../../src/utils/ColorsFunctions";
import { useAppSelector } from "../../../src/hooks/reduxHooks";

const HeadsetIcon = (props: { style?: StyleProp<ViewStyle> }) => {
	const user = useAppSelector((s) => s.auth.subUser!);

  return (
    <Svg
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill={getPrimaryColor(user)}
      {...props}
    >
      <Path d="M24.0764 11.293V10.4618C24.0764 4.70064 19.3758 0 13.6147 0C7.8535 0 3.15287 4.70064 3.15287 10.4618V11.293C1.31847 11.9809 0 13.758 0 15.8217C0 18.4873 2.17834 20.6656 4.84395 20.6656H6.59236C7.05096 20.6656 7.42357 20.293 7.42357 19.8344V11.8089C7.42357 11.3503 7.05096 10.9777 6.59236 10.9777H5.78981V10.4618C5.78981 6.13376 9.28662 2.63694 13.6147 2.63694C17.9427 2.63694 21.4395 6.13376 21.4395 10.4618V10.9777H20.6369C20.1783 10.9777 19.8057 11.3503 19.8057 11.8089V19.8344C19.8057 20.293 20.1783 20.6656 20.6369 20.6656H21.0096C20.1783 22.586 18.344 23.9331 16.1656 24.1051C16.051 23.5605 15.5637 23.1306 14.9618 23.1306H12.2389C11.551 23.1306 11.0064 23.6752 11.0064 24.3631V25.7675C11.0064 26.4554 11.551 27 12.2389 27H14.9618C15.5637 27 16.0796 26.5701 16.1656 25.9682C19.4045 25.7962 22.0987 23.5892 23.0159 20.6083C25.3662 20.293 27.2006 18.258 27.2006 15.8217C27.2293 13.7293 25.9108 11.9809 24.0764 11.293Z" />
      <Path d="M15.6 23C16.3 23 16.8667 23.4444 17 24.0074V25.9333C16.9 26.5556 16.3 27 15.6 27H12.4333C11.6333 27 11 26.437 11 25.7259V24.2741C11 23.563 11.6333 23 12.4333 23H15.6Z" />
    </Svg>
  );
};
export default HeadsetIcon;
